<template>
  <v-data-table
    :headers="itemGroupDataTableHeaders"
    :items="itemGroupList"
    class="elevation-1"
    show-expand
    single-expand
    item-key="Name"
    :loading="isLoadingItemGroup"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    :search="searchItemGroup"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('item_group_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchItemGroup"
          append-icon="mdi-magnify"
          :label="$t('item_group_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditItemGroupDialog" fullscreen persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
              {{ $t('item_group_new_btn') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ itemGroupDialogTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <ValidationObserver ref="itemGroup">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('item_group_name')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedItemGroup.Name"
                          :label="$t('item_group_name')"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('item_group_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-data-table
              :headers="itemGroupItemDataTableHeaders"
              :items="editedItemGroup.Items"
              :search="searchItemGroupItem"
              class="elevation-1  mt-5 mx-10"
              hide-default-footer
              disable-pagination
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              :header-props="headerProps"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchItemGroupItem"
                    append-icon="mdi-magnify"
                    :label="$t('item_group_search_label')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog v-model="isShowEditItemGroupItemDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-8"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="isAllTextFieldDisable"
                      >
                        {{ $t('item_group_item_btn') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ itemGroupItemDialogTitle }}</span>
                        <!--dialog的標題-->
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="itemGroupItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <item-filter-all-type-autocomplete
                                  :fatherEditedItem="editedItem"
                                  :editedItemIndex="editedItemGroupItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedItem="setEditedItem"
                                  v-if="
                                    editedItemGroupItemIndex === -1 && isShowEditItemGroupItemDialog
                                  "
                                  refName="itemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedItem.Number"
                                    :label="$t('quotation_item_number')"
                                    required
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedItem.Name"
                                    required
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditItemGroupItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addItemGroupItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteItemGroupItemDialog"
                    :deleteMessage="'item_group_item_delete_dialog_message'"
                    @closeDelete="closeDeleteItemGroupItem"
                    @confirmDelete="confirmDeleteItemGroupItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <!-- <v-icon
                  small
                  class="mr-2"
                  @click="isShowEditItemGroupItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisable"
                >
                  mdi-pencil
                </v-icon> -->
                <v-btn
                  icon
                  @click="isShowDeleteItemGroupItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisable"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedItemGroup"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedItemGroup"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isAllTextFieldDisable"
          :isLoadingSaveBtn="isLoadingSaveBtn"
          :isShowDeleteDialog="isShowDeleteItemGroupDialog"
          :deleteMessage="'item_group_delete_dialog_message'"
          @closeDelete="closeDeleteItemGroup"
          @confirmDelete="confirmDeleteItemGroup"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="isShowEditItemGroupBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="isShowDeleteItemGroupBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" style="background-color: rgb(223, 219, 219);">
        <v-simple-table style="background-color: rgb(223, 219, 219);">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('quotation_item_number') }}
                </th>
                <th class="text-left">
                  {{ $t('quotation_item_name') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="simpleItem in item.Items" :key="simpleItem.Number">
                <td class="text-left">{{ simpleItem.Number }}</td>
                <td class="text-left">{{ simpleItem.Name }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { HttpItemGroup } from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ItemFilterAllTypeAutocomplete from '@/components/ItemFilterAllTypeAutocomplete.vue'

export default {
  components: { ItemFilterAllTypeAutocomplete, DeleteDialog },
  name: 'ItemGroup',
  data: () => ({
    isShowEditItemGroupDialog: false,
    itemGroupList: [],
    editedItemGroupIndex: -1,
    searchItemGroup: '',
    editedItemGroup: {
      Name: '',
      Items: []
    },
    defaultItemGroup: {
      Name: '',
      Items: []
    },
    isLoadingItemGroup: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteItemGroupDialog: false,

    isShowEditItemGroupItemDialog: false,
    isShowDeleteItemGroupItemDialog: false,
    searchItemGroupItem: '',
    editedItemGroupItemIndex: -1,
    editedItem: {
      Number: '',
      Name: ''
    },
    defaultItem: {
      Number: '',
      Name: ''
    }
  }),
  async mounted () {
    this.getItemGroup()
  },
  computed: {
    itemGroupDataTableHeaders () {
      return [
        { text: this.$t('item_group_name'), align: 'start', value: 'Name' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    itemGroupItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), value: 'Number' },
        { text: this.$t('quotation_item_name'), value: 'Name' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    itemGroupDialogTitle () {
      return this.editedItemGroupIndex === -1
        ? this.$t('item_group_new_card_title')
        : this.$t('item_group_edit_card_title')
    },
    itemGroupItemDialogTitle () {
      return this.editedItemGroupItemIndex === -1
        ? this.$t('item_group_item_new_dialog_title')
        : this.$t('item_group_item_edit_dialog_title')
    }
  },
  methods: {
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setEditedItem (val) {
      this.editedItem = JSON.parse(JSON.stringify(val))
    },
    async getItemGroup () {
      this.isLoadingItemGroup = true
      let response = await HttpItemGroup.GetItemGroup()
      this.isLoadingItemGroup = false
      this.itemGroupList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditItemGroupBtn (item) {
      this.editedItemGroupIndex = this.itemGroupList.indexOf(item)
      this.editedItemGroup = JSON.parse(JSON.stringify(item))
      this.isShowEditItemGroupDialog = true
    },
    async closeEditedItemGroup () {
      this.isShowEditItemGroupDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        this.editedItemGroup = JSON.parse(JSON.stringify(this.defaultItemGroup))
        this.editedItemGroupIndex = -1
      })
      await this.getItemGroup()
    },
    async saveEditedItemGroup () {
      const isValid = await this.$refs.itemGroup.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingItemGroup = true
        if (this.editedItemGroupIndex !== -1) {
          await HttpItemGroup.UpdateItemGroup(this.editedItemGroup)
        } else {
          await HttpItemGroup.AddItemGroup(this.editedItemGroup)
        }
        this.closeEditedItemGroup()
      }
    },
    isShowDeleteItemGroupBtn (item) {
      this.editedItemGroupIndex = this.itemGroupList.indexOf(item)
      this.editedItemGroup = JSON.parse(JSON.stringify(item))
      this.isShowDeleteItemGroupDialog = true
    },
    async confirmDeleteItemGroup () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      this.isLoadingItemGroup = true
      await HttpItemGroup.DeleteItemGroup(this.itemGroupList[this.editedItemGroupIndex].Id)
      this.closeDeleteItemGroup()
    },
    async closeDeleteItemGroup () {
      this.isShowDeleteItemGroupDialog = false
      this.isAllTextFieldDisable = false
      this.isLoadingItemGroup = false
      this.isLoadingSaveBtn = false
      this.$nextTick(() => {
        this.editedItemGroup = JSON.parse(JSON.stringify(this.defaultItemGroup))
        this.editedItemGroupIndex = -1
      })
      await this.getItemGroup()
    },

    isShowEditItemGroupItemDialogBtn (item) {
      this.editedItemGroupItemIndex = this.editedItemGroup.Items.indexOf(item)
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.isShowEditItemGroupItemDialog = true
    },

    isShowDeleteItemGroupItemDialogBtn (item) {
      this.editedItemGroupItemIndex = this.editedItemGroup.Items.indexOf(item)
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.isShowDeleteItemGroupItemDialog = true
    },

    confirmDeleteItemGroupItem () {
      this.editedItemGroup.Items.splice(this.editedItemGroupItemIndex, 1)
      this.closeDeleteItemGroupItem()
    },

    async closeEditItemGroupItem () {
      this.isShowEditItemGroupItemDialog = false
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedItemGroupItemIndex = -1
      })
      await this.getItemGroup()
    },

    async closeDeleteItemGroupItem () {
      this.isShowDeleteItemGroupItemDialog = false
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedItemGroupItemIndex = -1
      })
      await this.getItemGroup()
    },
    // 新增副品號的部分(儲存的部分)
    async addItemGroupItem () {
      const isValid = await this.$refs.itemGroupItem.validate()
      if (isValid) {
        if (this.editedItemGroupItemIndex > -1) {
          this.editedItemGroup.Items.splice(this.editedItemGroupItemIndex, 1, this.editedItem)
        } else {
          this.editedItemGroup.Items.push(this.editedItem)
        }
        this.closeEditItemGroupItem()
      }
    }
  }
}
</script>
